import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class PlaybackControlsController extends BridgeComponent {
  static component = "play-button";
  static targets = [
    "progressBar",
    "currentTime",
    "duration",
    "hideable",
    "muted",
    "unmuted",
    "playback0_9",
    "playback1",
    "playback1_1",
    "playback1_5",
    "playback2",
    "airplay",
    "chromecast",
  ]
  static values = {
    itemId: Number,
    itemType: String,
    feedItemUrl: String,
    duration: Number
  }

  connect() {
    this.muted = false;
    this.currentSpeed = 1;
    this.send("connect", { feedItemUrl: this.feedItemUrlValue }, (response) => {
      if (response.data.supportsAirplay) {
        this.airplayTarget.classList.remove("hidden");
      }
      if (response.data.supportsChromecast) {
        this.chromecastTarget.classList.remove("hidden");
      }
    });

    window.addEventListener("supercast-timeupdate", this.onTimeUpdate.bind(this));
  }

  onTimeUpdate(event) {
    if (event.detail.itemId == this.itemIdValue && event.detail.itemType == this.itemTypeValue) {
      this.show();
      this.updateProgress(event);
    } else {
      this.hide();
    }
  }

  updateProgress(event) {
    if (!this.hasProgressBarTarget) {
      return;
    }

    this.progressBarTarget.value = (event.detail.currentTime / event.detail.duration) * 100;
    this.currentTimeTarget.textContent = this.formatTime(event.detail.currentTime);
    this.durationTarget.textContent = this.formatTime(event.detail.duration);
  }

  show() {
    this.hideableTargets.forEach(target => target.classList.remove("opacity-0"));
  }

  hide() {
    this.hideableTargets.forEach(target => target.classList.add("opacity-0"));
  }

  togglePlaybackRate() {
    let newSpeed = this.currentSpeed;
    if (this.currentSpeed == 1) {
      newSpeed = 1.1;
    } else if (this.currentSpeed == 1.1) {
      newSpeed = 1.5;
    } else if (this.currentSpeed == 1.5) {
      newSpeed = 2;
    } else if (this.currentSpeed == 2) {
      newSpeed = 0.9;
    } else {
      newSpeed = 1;
    }

    this.send("togglePlaybackRate", { speed: newSpeed }, () => {
      this.currentSpeed = newSpeed;
      this.playback0_9Target.hidden = newSpeed !== 0.9;
      this.playback1Target.hidden = newSpeed !== 1;
      this.playback1_1Target.hidden = newSpeed !== 1.1;
      this.playback1_5Target.hidden = newSpeed !== 1.5;
      this.playback2Target.hidden = newSpeed !== 2;
    });
  }

  jumpBack() {
    this.send("jumpBack");
  }

  jumpForward() {
    this.send("jumpForward");
  }

  toggleMute() {
    this.send("toggleMute", {}, () => {
      this.muted = !this.muted;
      this.mutedTarget.hidden = !this.muted;
      this.unmutedTarget.hidden = this.muted;
    });
  }

  showAirplay() {
    this.send("airplay");
  }

  showChromecast() {
    this.send("cast");
  }

  seek(e) {
    const percentage = e.currentTarget.value;
    this.send("seek", { time: (percentage / 100) * this.durationValue });
  }

  formatTime(time) {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}